import EntrySliderHandler from "./components/entrySliderHandler"
import EntriesSwiperHandler from "./components/entriesSwiperHandler"
import ThemeController from "./components/themeController"
import NavHandler from "./components/navHandler"
import IframeTitleHandler from "./components/iframeTitleHandler"
import MemberGalleryHandler from "./components/memberGalleryHandler"
import FilterHandler from "./components/filterHandler"
import ArticleSwiperHandler from "./components/articleSwiperHandler"
import WorksTeaserHandler from "./components/worksTeaserHandler"
import WorksImagesHandler from "./components/worksImagesHandler"
import WorksFilterToggle from "./components/worksFilterToggle"
import WorksFilterHandler from "./components/worksFilterHandler"

document.addEventListener("DOMContentLoaded", () => {
  if (document.documentElement.dataset.root === "true") {
    new ThemeController({selector: "#image_block_ma2bpx6q", threshold: 0.2})
  }
  new NavHandler()
  new IframeTitleHandler()

  setTimeout(() => {
    document.querySelector(".header__inner")?.classList.add("expanded")
    const hero = document.querySelector(".hero")
    if (hero) {
      document.querySelector(".hero__info")?.classList.add("hero__info--active")
      setTimeout(() => {
        document.querySelector(".hero__text")?.classList.add("hero__text--active")
      }, 300)
      setTimeout(() => {
        document.querySelector(".hero__button")?.classList.add("hero__button--active")
      }, 450)
    }
  }, 1000)
  if (document.querySelector(".article-grid")) {
    new FilterHandler()
  }
  if (document.querySelector(".entries-slider")) {
    new EntrySliderHandler()
    new EntriesSwiperHandler()
  }
  if (document.querySelector(".article-slider")) {
    new ArticleSwiperHandler()
  }
  if (document.querySelector(".works-teaser__slider")) {
    new WorksTeaserHandler()
  }
  if (document.querySelector(".works__images--slider")) {
    new WorksImagesHandler()
  }
  if (document.querySelector(".index-works__toggle")) {
    new WorksFilterToggle()
  }
  if (document.querySelector(".index-works")) {
    new WorksFilterHandler()
  }
  if (window.innerWidth <= 810) new MemberGalleryHandler()
})
